import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';
import globalCourseStore from '../../../../../stores/global-course-store';
import globalProgramStore from '../../../../../stores/program-store';

export const updateLectureBreakAndAttendanceOperation = async (
  lectureId: number,
  lectureAttendanceSessionNumber: number | null,
  breakMinutesTime: number | null,
  setIsLoading: (loading: boolean) => void,
  onSuccess?: () => void,
) => {
  try {
    setIsLoading(true);

    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    if (!currentProgramId || !currentCourseId) {
      toast.error('לא ניתן לעדכן את ההרצאה - מידע חסר');
      return;
    }

    const lecture = globalCourseStore
      .getCurrentCourse()
      ?.details?.lectures?.find((lec) => lec.item.id === lectureId);

    if (!lecture) {
      toast.error('לא נמצאה הרצאה מתאימה');
      return;
    }

    const res = await appApi.updateLectureDetails(
      currentProgramId,
      currentCourseId,
      lectureId,
      lecture.item.lectureName,
      lecture.item.isRemote,
      {
        lectureAttendanceSessionNumber,
        breakMinutesTime,
      },
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    await globalCourseStore.fetchCourseDetails(
      currentProgramId,
      currentCourseId,
    );

    toast.success('פרטי ההרצאה עודכנו בהצלחה');
    onSuccess?.();
  } catch (e) {
    console.error(
      `updateLectureBreakAndAttendanceOperation failed for lectureId: ${lectureId} with error: ${e}`,
    );
    toast.error('משהו קרה, לא ניתן לעדכן את פרטי ההרצאה...');
  } finally {
    setIsLoading(false);
  }
};
